<template>
  <cta-tooltip title="שנעשה את זה ביחד?" image-path="/images/advisory/person-raised-hand.svg"
               cta-text="לתכנית הייעוץ" :allow-dismiss="allowDismiss"
               @click="handleClick" @dismiss="handleDismiss">
      <div class="ri-body">בתהליך הייעוץ האישי של רייזאפ, נסתכל על התמונה הכלכלית המלאה ונבנה ביחד תוכנית שתעזור לך להשיג את המטרות שלך.</div>
  </cta-tooltip>
</template>

<script>
import CtaTooltip from '@/base-components/CtaTooltip';
import Segment from '@/Segment';
import router from '@/router';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AdvisoryCtaTooltip',
  components: { CtaTooltip },
  created() {
    Segment.trackUserGot('AdvisoryCtaTooltip_Shown', { type: this.type });
  },
  props: {
    allowDismiss: {
      type: Boolean,
      required: false,
      default: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('advisory', ['advisoryFlowSharedUTMParams']),
  },
  methods: {
    ...mapActions('modalRootStore', ['closeAllModals']),
    handleClick() {
      Segment.trackUserGot('AdvisoryCtaTooltip_OpenFlowClicked', { type: this.type });
      router.push({
        path: '/advisory-plan',
        query: {
          ...this.advisoryFlowSharedUTMParams,
          utm_content: 'banner',
          utm_campaign: 'plan-ahead',
        },
      });
      this.closeAllModals();
    },
    handleDismiss() {
      Segment.trackUserGot('AdvisoryCtaTooltip_Dismiss_Clicked', { type: this.type });
      this.$emit('dismiss');
    },
  },
};
</script>

<style scoped>

</style>
